import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSession } from '../../features/auth/hooks'
import { useAuthStore } from '../../stores/authStore'
import { LoadingState } from '../ui/LoadingState'

export function ProtectedRoute() {
  const location = useLocation()
  const token = useAuthStore((s) => s.accessToken)
  const { isPending } = useSession()

  // Still trying to restore the session from the refresh cookie — don't
  // redirect yet, or a reload will always bounce to /login.
  if (isPending) {
    return <LoadingState fullPage />
  }

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
